/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Handout: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M17.5 13C19.433 13 21 11.433 21 9.5C21 7.567 19.433 6 17.5 6C15.567 6 14 7.567 14 9.5C14 11.433 15.567 13 17.5 13Z' fill='currentColor' />
    <path d='M9.5 7C11.433 7 13 5.433 13 3.5C13 1.567 11.433 0 9.5 0C7.567 0 6 1.567 6 3.5C6 5.433 7.567 7 9.5 7Z' fill='currentColor' />
    <path
      d='M22.996 17.908C22.903 16.902 21.949 15 19 15H13.998C13.085 13.786 11.633 13 10 13H7.472C5.94 11.372 3.06 11 2 11H0V19.618L7.369 23.303C7.93 23.583 8.543 23.724 9.159 23.724C9.644 23.724 10.132 23.636 10.595 23.459L23.066 18.662L22.996 17.908ZM9.877 21.592C9.352 21.794 8.765 21.764 8.264 21.514L2 18.382V13C3.074 13 5.402 13.462 6.181 14.573L6.479 15H10C11.304 15 12.416 15.836 12.829 17H7V19H15V18C15 17.657 14.966 17.323 14.899 17H19C19.848 17 20.338 17.217 20.622 17.459L9.877 21.592Z'
      fill='currentColor'
    />
  </React.Fragment>
)
